import usePosSettingsQuery from "@/shared/queries/pos/usePosSettingsQuery";
import { useCallback, useMemo } from "react";
import { posDeliveryMethods as allPosDeliveryMethods } from "../utils/constant";
import usePosUserSettingsQuery from "../queries/pos/usePosUserSettingsQuery";
import { PosSettings } from "../utils/interfaces";

const usePosSettingsHook = () => {
  const query = usePosSettingsQuery();
  const posUserQuery = usePosUserSettingsQuery();

  const posDeliveryMethods = useMemo(
    () =>
      allPosDeliveryMethods.filter((method) =>
        posUserQuery?.data?.delivery_method_options?.includes(method.value),
      ),
    [posUserQuery?.data?.delivery_method_options],
  );

  const refetch = useCallback(() => {
    query.refetch();
    posUserQuery.refetch();
  }, [query.refetch, posUserQuery.refetch]);

  const settings = useMemo(
    () =>
      ({
        ...query?.data,
        ...posUserQuery?.data,
        item_id: query?.data?.item_id,
      } as PosSettings),
    [query?.data, posUserQuery?.data],
  );

  return {
    isPending: query.isPending || posUserQuery.isPending,
    isError: query.isError || posUserQuery.isError,
    isSuccess: query.isSuccess && posUserQuery.isSuccess,
    refetch,
    settings,
    posDeliveryMethods,
  };
};

export default usePosSettingsHook;
